/* Mama's Den Help: navigation + FAQ helper. Keyword matching over a built-in knowledge base.
   No third-party services, no API keys. Product search uses the store's own /search/suggest.json. */
(function () {
  'use strict';
  var root = document.querySelector('[data-md-help]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('md-help-config').textContent); } catch (e) {}
  var ROOT = (cfg.root || '/').replace(/\/?$/, '/');
  var EMAIL = cfg.email || 'ossoaaron1@gmail.com';
  var COLLECTIONS = (cfg.collections && cfg.collections.length) ? cfg.collections : [
    { title: 'Strollers', url: '/collections/strollers' }, { title: 'Feeding', url: '/collections/feeding' },
    { title: 'Bottle Warmers', url: '/collections/bottle-warmers' }, { title: 'Diapering', url: '/collections/diapering' },
    { title: 'Clothing', url: '/collections/clothing' }, { title: 'Holiday', url: '/collections/holiday' },
    { title: 'Activity Gyms', url: '/collections/activity-gyms' }, { title: 'Playpens', url: '/collections/playpens' }
  ];
  function page(handle) { return ROOT + 'pages/' + handle; }
  function link(href, text) { return '<a href="' + href + '">' + text + '</a>'; }
  var MAIL = link('mailto:' + EMAIL, EMAIL);

  var launcher = root.querySelector('[data-md-help-toggle]');
  var panel = root.querySelector('#md-help-panel');
  var closeBtn = root.querySelector('[data-md-help-close]');
  var log = root.querySelector('[data-md-help-log]');
  var form = root.querySelector('[data-md-help-form]');
  var input = root.querySelector('[data-md-help-input]');
  var chips = root.querySelector('[data-md-help-chips]');
  var awaitingSearch = false;
  var STORE_KEY = 'mdHelpLog';

  /* ---------- Knowledge base (from the store's own FAQ, Shipping, Returns, Our Story, Contact pages) ---------- */
  var KB = [
    { id: 'health', words: ['fever','sick','rash','medicine','medication','dose','dosage','doctor','pediatrician','allergy','allergic','choke','choking','sids','safe sleep','is it safe','is this safe','safe for','safety','health','medical','symptom','colic','reflux','vaccine','jaundice','breathing','teething pain','diagnos','injur','hurt'],
      answer: '<p>I\'m not able to give medical, health, or safety advice, and I\'d never want to guess about your little one. For anything about your baby\'s health or sleep, please check with your pediatrician.</p><p>For product details, each product page lists what the maker provides, and you can always email us at ' + MAIL + '.</p>' },
    { id: 'discount', words: ['discount','coupon','promo','code','welcome10','sale','deal','first order','percent off','% off','save'],
      answer: '<p>Welcome to the family! Use code <strong>WELCOME10</strong> at checkout for <strong>10% off your first order</strong>. It works once per customer, for people who haven\'t ordered with us before.</p>' },
    { id: 'track', words: ['track','tracking','where is my order','where\'s my order','order status','has my order shipped','not arrived','hasn\'t arrived','late','delayed','lost','stolen','missing package'],
      answer: '<p>You\'ll get a tracking email as soon as each item ships (please peek in spam or promotions too). If you have an account, you can also check your order from the ' + link(ROOT + 'account', 'Account page') + '.</p><p>Tracking says delivered but no package? Check around your home and with neighbors and give it one business day, then email ' + MAIL + ' with your order number. More on the ' + link(page('shipping'), 'Shipping page') + '.</p>' },
    { id: 'boxes', words: ['more than one box','separate box','two boxes','multiple boxes','split','different days','partial','only got part','one item missing'],
      answer: '<p>That\'s normal, no worries. Our items ship from different partner warehouses, so an order with several items may arrive in separate boxes on different days. You never pay extra for split packages.</p>' },
    { id: 'damaged', words: ['damaged','broken','defective','wrong item','arrived broken','doesn\'t work','not working','faulty'],
      answer: '<p>We\'re so sorry! Damaged, defective, or wrong items are always handled at no cost to you. Please email ' + MAIL + ' with your order number and photos of the item and the box, and we\'ll make it right with a replacement or refund.</p>' },
    { id: 'returns', words: ['return','returns','refund','money back','send back','exchange','swap','30 day','30-day','cancel'],
      answer: '<p>You have <strong>30 days from delivery</strong> to request a return.</p><ul><li>Email ' + MAIL + ' first with your order number. Please don\'t mail anything back until we send instructions and the right address.</li><li>Items should be unused and in original packaging. Clothing must be unworn with tags. Feeding items can only be returned sealed.</li><li>Approved refunds go back to your original payment method.</li></ul><p>All the details are on our ' + link(page('returns'), 'Returns &amp; Refunds page') + '.</p>' },
    { id: 'where_ship', words: ['international','canada','outside the us','other countries','ship to','do you ship','overseas','worldwide','uk','mexico'],
      answer: '<p>Right now we ship within the <strong>United States</strong>. See the ' + link(page('shipping'), 'Shipping page') + ' for details.</p>' },
    { id: 'delivery', words: ['how long','delivery time','when will','arrive','take to ship','processing','business days','how fast','express','rush','quickly','soon'],
      answer: '<p>Most orders are processed within a few business days, and delivery usually takes several business days after that. Some items ship from overseas partner warehouses and can take longer, and busy seasons can add a little time.</p><p>Need it sooner? <strong>Express shipping is $15</strong>. Your exact options are always shown at checkout. More on the ' + link(page('shipping'), 'Shipping page') + '.</p>' },
    { id: 'shipping', words: ['shipping','ship','postage','delivery cost','free shipping','how much is shipping','shipping cost','delivery'],
      answer: '<p>Here\'s how shipping works in the U.S.:</p><ul><li><strong>Standard:</strong> $8, or <strong>free on orders $70+</strong></li><li><strong>Express:</strong> $15</li><li>Some items always ship free, and you\'ll see that at checkout.</li></ul><p>You\'ll get tracking by email when each item ships. Full details are on our ' + link(page('shipping'), 'Shipping page') + '.</p>' },
    { id: 'contact', words: ['contact','email','reach','talk to','speak to','human','person','someone','phone','call','number','address','customer service','support','help me'],
      answer: '<p>We\'d love to hear from you! The best way to reach us is email: ' + MAIL + '. We\'ll get back to you as soon as we can.</p><p>You can also use our ' + link(page('contact'), 'contact form') + '.</p>' },
    { id: 'story', words: ['about','who are you','your story','our story','who runs','owner','mamas den','mama\'s den','family business','brand'],
      answer: '<p>Mama\'s Den is a cozy corner for mamas and grandmas on the go. Every piece is chosen with love, a little worry, and a lot of care, the way you\'d choose it yourself. You\'re family here.</p><p>Read more in ' + link(page('our-story'), 'Our Story') + '.</p>' },
    { id: 'faq', words: ['faq','questions','common questions','help center'],
      answer: '<p>Our ' + link(page('faq'), 'FAQ page') + ' covers shipping, tracking, split boxes, returns, and damaged items. Ask me anything here too!</p>' },
    { id: 'thanks', words: ['thank','thanks','thx','appreciate','great','perfect','awesome'],
      answer: '<p>You\'re so welcome! Anything else I can help you find?</p>' },
    { id: 'hello', words: ['hello','hi','hey','good morning','good evening','howdy'],
      answer: '<p>Hi there! I can help with shipping, returns, discounts, or finding a product. What can I do for you?</p>' }
  ];
  var FALLBACK = '<p>I\'m not sure about that one. You can email us at ' + MAIL + ' and we\'ll get back to you.</p>';
  var GREETING = '<p>Hi, welcome to Mama\'s Den! 👋 I\'m a little helper for finding your way around.</p><p>Ask me about shipping, returns, or where to find something, or tap a button below.</p>';
  var FIND_PROMPT = '<p>Happy to help you look! What are you searching for? For example: <em>diaper bag</em>, <em>bottle warmer</em>, or <em>playpen</em>.</p>' + collectionList();

  function collectionList() {
    return '<p>Or browse by category:</p><ul>' + COLLECTIONS.map(function (c) { return '<li>' + link(c.url, esc(c.title)) + '</li>'; }).join('') + '</ul>';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return ' ' + String(s).toLowerCase().replace(/[’‘]/g, "'").replace(/[^a-z0-9'%$+ -]/g, ' ').replace(/\s+/g, ' ').trim() + ' '; }
  function has(text, w) {
    if (w.indexOf(' ') > -1 || w.length > 5) return text.indexOf(w) > -1;
    if (w.length <= 4) return text.indexOf(' ' + w + ' ') > -1 || text.indexOf(' ' + w + 's ') > -1 || text.indexOf(' ' + w + 'es ') > -1;
    return text.indexOf(' ' + w) > -1;
  }

  function matchIntent(text) {
    var best = null, bestScore = 0;
    for (var i = 0; i < KB.length; i++) {
      var score = 0;
      for (var j = 0; j < KB[i].words.length; j++) if (has(text, KB[i].words[j])) score += KB[i].words[j].length > 6 ? 2 : 1;
      if (KB[i].id === 'health' && score) return KB[i];
      if (score > bestScore) { best = KB[i]; bestScore = score; }
    }
    return best;
  }
  function matchCollection(text) {
    for (var i = 0; i < COLLECTIONS.length; i++) {
      var t = COLLECTIONS[i].title.toLowerCase(), singular = t.replace(/s$/, '');
      if (text.indexOf(' ' + t) > -1 || text.indexOf(' ' + singular) > -1) return COLLECTIONS[i];
    }
    return null;
  }
  function searchTerm(raw) {
    var m = raw.match(/(?:where (?:can|do) i (?:find|get|buy)|where (?:is|are)(?: the)?|do you (?:have|sell|carry|stock)|looking for|search(?: for)?|find(?: me)?|i need|i want|show me)\s+(?:a |an |the |some |any )?(.+)/i);
    return m ? m[1].replace(/[?.!]+$/, '').trim() : null;
  }

  /* ---------- Rendering ---------- */
  function add(role, html, persist) {
    var div = document.createElement('div');
    div.className = 'md-help__msg md-help__msg--' + role;
    div.innerHTML = html;
    log.appendChild(div);
    log.scrollTop = log.scrollHeight;
    if (persist !== false) save(role, html);
    return div;
  }
  function typing() {
    var d = document.createElement('div');
    d.className = 'md-help__msg md-help__msg--bot md-help__typing';
    d.setAttribute('aria-label', 'Typing');
    d.innerHTML = '<span></span><span></span><span></span>';
    log.appendChild(d); log.scrollTop = log.scrollHeight;
    return d;
  }
  function reply(html, delay) {
    var t = typing();
    setTimeout(function () { t.remove(); add('bot', html); }, delay || 450);
  }
  function save(role, html) {
    try { var a = JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]'); a.push([role, html]); sessionStorage.setItem(STORE_KEY, JSON.stringify(a.slice(-30))); } catch (e) {}
  }
  function restore() {
    try { var a = JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]'); a.forEach(function (m) { add(m[0], m[1], false); }); return a.length; } catch (e) { return 0; }
  }

  /* ---------- Product search via the store's own predictive search ---------- */
  function money(p) { var n = parseFloat(p); return isNaN(n) ? '' : '$' + n.toFixed(2); }
  function search(term) {
    var t = typing();
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        t.remove();
        var res = (data && data.resources && data.resources.results) || {};
        var prods = (res.products || []).slice(0, 4), cols = (res.collections || []).slice(0, 2);
        var all = (cfg.searchUrl || ROOT + 'search') + '?type=product&q=' + encodeURIComponent(term);
        if (!prods.length && !cols.length) {
          add('bot', '<p>I couldn\'t find anything for “' + esc(term) + '”. Try another word, or browse a category below. You can also email ' + MAIL + ' and we\'ll help you look.</p>' + collectionList());
          return;
        }
        var items = cols.map(function (c) {
          return '<li class="md-help__result"><a href="' + esc(c.url) + '"><span class="md-help__thumb" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg></span><span class="md-help__rtext"><span class="md-help__rtitle">' + esc(c.title) + '</span><span class="md-help__rprice">Collection</span></span></a></li>';
        }).concat(prods.map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          return '<li class="md-help__result"><a href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="md-help__thumb" aria-hidden="true"></span>') +
            '<span class="md-help__rtext"><span class="md-help__rtitle">' + esc(p.title) + '</span><span class="md-help__rprice">' +
            money(p.price) + (p.available === false ? ' · Sold out' : '') + '</span></span></a></li>';
        }));
        add('bot', '<p>Here\'s what I found for “' + esc(term) + '”:</p><ul class="md-help__results">' + items.join('') + '</ul><p>' + link(all, 'See all results') + '</p>');
      })
      .catch(function () {
        t.remove();
        add('bot', '<p>Sorry, search isn\'t loading right now. You can ' + link((cfg.searchUrl || ROOT + 'search') + '?q=' + encodeURIComponent(term), 'search the store here') + ', or email ' + MAIL + '.</p>');
      });
  }

  /* ---------- Conversation ---------- */
  function handle(raw) {
    raw = String(raw || '').trim();
    if (!raw) return;
    add('user', esc(raw));
    var text = norm(raw), lower = raw.toLowerCase();

    if (lower === 'find a product') { awaitingSearch = true; return reply(FIND_PROMPT); }
    if (lower === 'contact us') { awaitingSearch = false; return reply(KB.filter(function (k) { return k.id === 'contact'; })[0].answer); }

    var intent = matchIntent(text);
    if (intent && intent.id === 'health') { awaitingSearch = false; return reply(intent.answer); }

    var term = searchTerm(raw);
    if (term && !(intent && /^(shipping|returns|contact|discount|track|delivery)$/.test(intent.id) && !matchCollection(norm(term)))) {
      awaitingSearch = false; return search(term);
    }
    if (awaitingSearch && !intent) { awaitingSearch = false; return search(raw.replace(/[?.!]+$/, '')); }
    if (intent) { awaitingSearch = false; return reply(intent.answer); }

    var col = matchCollection(text);
    if (col) return search(raw.replace(/[?.!]+$/, ''));
    if (raw.split(/\s+/).length <= 3) return search(raw.replace(/[?.!]+$/, ''));
    reply(FALLBACK);
  }

  /* ---------- Open / close, keyboard ---------- */
  function open() {
    panel.hidden = false;
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    launcher.setAttribute('aria-label', 'Close Mama\'s Den Help chat');
    requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-open'); }); });
    if (!log.childElementCount && !restore()) add('bot', GREETING);
    setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    panel.classList.remove('is-open');
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-label', 'Open Mama\'s Den Help chat');
    setTimeout(function () { panel.hidden = true; }, 220);
    launcher.focus({ preventScroll: true });
  }
  launcher.addEventListener('click', function () { panel.hidden ? open() : close(); });
  closeBtn.addEventListener('click', close);
  panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); close(); } });
  chips.addEventListener('click', function (e) { var b = e.target.closest('[data-q]'); if (b) handle(b.getAttribute('data-q')); });
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; handle(v); });

  window.MamasDenHelp = { open: open, close: close, ask: function (q) { if (panel.hidden) open(); handle(q); } };
})();
